<template>
    <div>
        <div class="modal fade" id="login" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true" data-bs-backdrop="true" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-lg modal-dialog-centered">
                <div class="modal-content exo-2" style="border-radius: 20px;" :style="skin.header_desktop.nav_bar">
                    <button id="closeLogin1" :style="skin.my_account.close_btn"  type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                    <h6 class="modal-title title text-center m-1 mb-5 p-0" id="exampleModalLabel">{{ translate('word') }}<br> {{ translate('word1') }}</h6>
                    <div class="modal-body p-1">
                        <div class="text-center">
                            <form @submit.prevent="login()" class="p-2 my-3">
                                <div class="w-100"> 
                                        <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100"> 
                                            <input v-model="username" id="username" type="text" :placeholder="translate('user')" class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
                                        </div>
                                        <div v-if="!resetPassword" class="pb-2 font-size-custom mb-3 my-1 d-flex justify-content-center"> 
                                            <input v-model="password" id="password" type="password" :placeholder="translate('password')" class="form-control input-login mr-sm-2  my-sm-0" maxlength="16" autocomplete="off"> 
                                        </div>
                                    </div>
                                <div class="d-flex mb-3 align-content-center justify-content-center">
                                    <button id="submit_btn" type="submit" class="btn p-2 login-btn" :style="{'background-color':skin.main_modal_background, 'color':skin.main_modal_text}" style="color:black;width: 100%;" :disabled="login_inProcess">{{ translate('log_in') }}</button>
                                </div>
                            </form>
                            <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name:"login",
    props:['skin','translation','language'],
    data(){
        return {
            username:"",
            password:"",
            resetPassword:false,
            status:{
                message:"",
                type:""
            },
            login_inProcess:false
        }
    },
    computed:{
    },
    methods:{
        async login(){
            this.login_inProcess = true;
            if(this.resetPassword){
                if(this.username!=""){
                    let reset = await axios.post(this.$store.getters["getDomain"]+"/swarm/remote/forgot_password",{
                        "email":this.username
                    })
                    if(reset.data.success){
                        this.status.message=reset.data.message;
                        this.status.type="success";
                    }
                    else{
                        this.status.message=reset.data.message;
                        this.status.type="danger";
                    }
                    this.resetPassword = false;
                }
                else{
                    this.status.message=this.translate("input_email");
                    this.status.type="danger"; 
                }
                this.login_inProcess = false;
            }
            else{
                let data = await this.$store.dispatch('login',{username:this.username,password:this.password});
                if(data=="success"){
                    console.log(data);
                    document.getElementById('closeLogin1').click();
                    this.$root.$emit('forceRender');
                    this.login_inProcess = false;
                    this.username = '';
                    this.password = '';
                    this.status.message = '';
                }
                else{
                    this.status.message=data;
                    this.status.type="danger";
                    this.login_inProcess = false;
                }
            }
            
        },
        reset_password(){
            this.resetPassword = true;
            this.login();
        },
        translate(text) {
            if(text){
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else{
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    }
}
</script>
<style scoped>
.title{
    font-family: "Exo 2", sans-serif;
    color: #ebebd3 !important;
    height: 60px !important;
    font-size: 1rem !important;
    font-weight: bold;
    margin-bottom: 12px;
    margin: 1rem auto;
}
.login-btn{
    font-family: "Exo 2", sans-serif;
    color: black !important;
    font-size: small !important;
    font-weight: bold;
    margin-bottom: 12px;
    margin: 1rem auto;
}
.exo-2> {
  font-family: "Exo 2", sans-serif !important;
}
.input-login{
    background-color: #020f1d;
    font-family: "Exo 2", sans-serif;
    border: none;
    color: #fff;
    font-size: medium;
    border-radius: 6px;
    padding: 10px 20px;
    line-height: .75em;
}
.modal-fade{
    border-radius: 10px 10px 10px 10px;
}
.modal-title {
    margin-left: 5%!important;
    margin-right: 5%!important;
    margin-top: 1.2rem!important;
    margin-bottom: 0!important;
    height: 60px;
    padding: 1rem!important;
    color: #fff;
    border-bottom: none;
    font-size: 20px;
    font-family: Exo 2, sans-serif;
}
.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}
.login-user-control{
    color: #fff;
    width: 200%;
    -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 20px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0 auto; /* Alinear horizontalmente */
    padding: 0.6rem 0 0.6rem;
    background-image: none;
    background-color: transparent;
    height: auto;
    font-family: Exo 2, sans-serif;
    font-weight: 800;
}
.modal-title {
    height: 80px;
    color: #fff;
    border-bottom: none;
    font-size: 20px;
    font-family: Exo 2, sans-serif;
}
.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .8;
}
.login-user-control,.submit_btn{
    text-align: center;
    color: #fff;
    width: 100%;
    -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 20px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0 ; /* Alinear horizontalmente */
    padding: 0.5rem 8rem;
    background-image: none;
    background-color: transparent;
    height: auto;
    font-family: Exo 2, sans-serif;
    font-weight: 800;
}
</style>
